import { Pipe, PipeTransform, NgModule, LOCALE_ID } from "@angular/core";
import { DatePipe, CommonModule } from "@angular/common";
import { PercentagePipe } from "./pourcentage.pipe";
import { TruncateDecimalPipe } from "./truncate-decimal.pipe";
import { CapitalizeFirstPipe } from "./capitalizeFirst.pipe";

// dateFormatPipe ===============================
@Pipe({
	name: "dateFormatPipe",
})
export class dateFormatPipe implements PipeTransform {
	constructor() {}

	transform(value: string, format: string = "dateTime") {
		const d = new DatePipe("en-US");
		var dateFormat = format == "dateTime" ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy";
		return d.transform(value, dateFormat, "UTC+1");
	}
}

// boolPipe ===============================
@Pipe({
	name: "boolPipe",
})
export class boolPipe implements PipeTransform {
	constructor() {}

	transform(value: boolean) {
		return value == true ? "Oui" : "Non";
	}
}

@NgModule({
	declarations: [dateFormatPipe, boolPipe, PercentagePipe, TruncateDecimalPipe, CapitalizeFirstPipe],
	imports: [CommonModule],
	providers: [{ provide: LOCALE_ID, useValue: "en-US" }],
	exports: [dateFormatPipe, boolPipe, PercentagePipe, TruncateDecimalPipe, CapitalizeFirstPipe],
})
export class CustomPipeModule {}
